import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { LayersForm } from '../Forms'
import * as ContentActions from '../../../actions/content'
import { notify as notifyAction } from '../../../actions/notifications'
import { Layers as LayersDOM } from '../../../components/Screens/Content'

class Layers extends PureComponent {
    static propTypes = {
        data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        fetchLayers: PropTypes.func.isRequired,
        isWorking: PropTypes.bool.isRequired,
        notify: PropTypes.func.isRequired,
        changeLayersArray: PropTypes.func.isRequired,
        pagination: PropTypes.shape({
            currentPage: PropTypes.number.isRequired,
            to: PropTypes.number.isRequired,
            total: PropTypes.number.isRequired,
        }).isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            search: '',
            showForm: false,
            selectedAll: false,
        }

        this.onClickCancel = this.onClickCancel.bind(this)
        this.onClickUpload = this.onClickUpload.bind(this)
        this.onClickUrl = this.onClickUrl.bind(this)
        this.onChangeSearch = this.onChangeSearch.bind(this)
        this.bulkSelectionAllLayers = this.bulkSelectionAllLayers.bind(this)
        this.bulkSelectionLayers = this.bulkSelectionLayers.bind(this)
        this.onDeleteLayer = this.onDeleteLayer.bind(this)
        this.resetSelection = this.resetSelection.bind(this)
        // this.onSubmit = this.onSubmit.bind(this)
    }

    componentDidMount() {
        this.loadData()
    }

    onClickCancel() {
        this.setState({ showForm: false })
    }

    onClickUpload() {
        this.setState({ showForm: true })
    }

    /**
     * Downloads a file
     * @param {String} url url of the file to download
     */
    // eslint-disable-next-line class-methods-use-this
    async onClickUrl(id) {
        console.log('url ', id)
        const { downloadLayer } = this.props
        await downloadLayer(id)
    }

    onChangeSearch({ target: { value } }) {
        this.setState({ search: value }, this.search)
    }

    buildNextPageFunc() {
        const { fetchLayers, isWorking, pagination } = this.props
        const { currentPage, to, total } = pagination

        if (!isWorking && to < total) {
            return () => fetchLayers(currentPage + 1)
        }

        return null
    }

    loadData() {
        const { fetchLayers } = this.props
        fetchLayers()
    }

    bulkSelectionLayers(e, id) {
        if (typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }

        const { data, changeLayersArray } = this.props
        const indexDevice = data.findIndex((device) => device.id === id)
        if (indexDevice > -1) {
            const { selected } = data[indexDevice]
            data[indexDevice].selected = !selected
            changeLayersArray(data)
        }
    }

    bulkSelectionAllLayers(e) {
        const { selectedAll } = this.state
        const { data, changeLayersArray } = this.props
        data.map((layer) => (layer.selected = !selectedAll))
        changeLayersArray(data)
        this.setState({ selectedAll: !selectedAll })
    }

    async onDeleteLayer(id) {
        const { deleteLayer } = this.props
        await deleteLayer(id)
    }

    resetSelection() {
        const { data, changeLayersArray } = this.props
        this.setState({ selectedAll: false })
        const resetedLayers = data.map((layer) => {
            return { ...layer, selected: false }
        })
        changeLayersArray(resetedLayers)
    }

    render() {
        const { data } = this.props
        const { showForm, selectedAll } = this.state
        return (
            <LayersDOM
                data={data}
                nextPage={this.buildNextPageFunc()}
                onChangeSearch={this.onChangeInput}
                onClickUpload={this.onClickUpload}
                onDeleteLayer={this.onDeleteLayer}
                bulkSelectionLayers={this.bulkSelectionLayers}
                bulkSelectionAllLayers={this.bulkSelectionAllLayers}
                selectedAll={selectedAll}
                resetSelection={this.resetSelection}
            >
                <LayersForm isOpen={showForm} onClickCancel={this.onClickCancel} />
            </LayersDOM>
        )
    }
}

const mapStateToProps = ({
    content: {
        isWorking: { layers: isWorking },
        layers: data,
        pagination: {
            layers: { currentPage, to, total },
        },
    },
}) => ({
    data,
    isWorking,
    pagination: {
        currentPage,
        to,
        total,
    },
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...ContentActions,
            notify: notifyAction,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(Layers)
